const getRecipentSource = paymentOriginId => {
  switch (paymentOriginId) {
    case 1:
      return 'pagarme';
    case 2:
      return 'zoop';
    case 3:
      return 'iugu';

    default:
      return '';
  }
};

export default getRecipentSource;
